import { useDispatch } from "react-redux";
import { AppActions } from "../CommonApp/appSlice";
import { AppDispatch } from "../Store";

export default function usePageLoader() {
  const dispatch = useDispatch<AppDispatch>();

  const setFullPageLoader = (open: boolean) => {
    return dispatch(AppActions.actions.setFullPageLoader(open));
  };
  return setFullPageLoader;
}
